export enum SearchModeEnum {
  ADVANCED = "ADVANCED",
  AD_HOC = "AD HOC",
}
